module.exports = __webpack_public_path__ + "static/img/John-Cartwright.2c4a2a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/John-Cartwright.jpg
// module id = +21R
// module chunks = 0